export enum FileUploadStatusCode {
  FAILED = 'REJECTED',
  ERROR = 'ERROR',
  SUCCESS = 'COMPLETED',
  WAITING = 'WAITING',
  PROCESSING = 'PROCESSING',
  PARTIAL_FAILURE = 'PARTIAL_FAILURE',
}

export type ErrorState =
  | FileUploadStatusCode.ERROR
  | FileUploadStatusCode.PARTIAL_FAILURE
  | FileUploadStatusCode.FAILED;

export type PollingState = FileUploadStatusCode.WAITING | FileUploadStatusCode.PROCESSING;

export type CompletedState =
  | FileUploadStatusCode.SUCCESS
  | FileUploadStatusCode.PARTIAL_FAILURE
  | FileUploadStatusCode.FAILED
  | FileUploadStatusCode.ERROR;

export interface SetupFrameInformation {
  fileId: string;
  fileName: string;
  uploadDate: Date | string;
  uploadStatusCode: FileUploadStatusCode;
  uploadUserName: string;
  progressPercentage?: number;
  recordsProcessed?: number;
  totalRecords?: number;
  processingState?: FileUploadStatusCode;
  errorDetail?: string;
}

export interface SetupDetailedFrameInformation {
  entityName: string;
  errorRecords: number;
  errors: { errorCode: string; errorMessage: string }[];
  newRecords: number;
  skippedRecords: number;
  totalRecords: number;
  updatedRecords: number;
}

export interface SetupDetails {
  hasErrors: boolean;
  fileName: string;
  statusCode: CompletedState;
  setupDetailResponse: SetupDetailedFrameInformation[];
}
